module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/feature-customer-978879440bcab158e309b1e70f1537ea.png";